module.exports = __webpack_public_path__ + "media/KarosOnline_Open_phone.a10375a3.mp4";